<template>
    <b-modal id="signing-modal" size="lg" title="Firmar certificado" no-close-on-esc no-close-on-backdrop>
        <b-row class="mb-2">
            <b-col>
                <b-form-group label="Certificación">
                    <b-form-radio-group :options="certifications" v-model="signingForm.certification"
                                        name="radio-certifications"></b-form-radio-group>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col cols="6">
                <b-form-group>
                    <b-checkbox v-model="signingForm.useAutograph">Firma autógrafa</b-checkbox>
                    <div v-if="signingForm.errors.noCheckSelected" class="invalid-feedback d-block" role="alert">
                        Selecciona al menos un tipo de firmado
                    </div>
                </b-form-group>
            </b-col>
            <b-col cols="6">
                <b-form-group>
                    <b-checkbox v-model="signingForm.useQRCode">Código QR</b-checkbox>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="mb-2">
            <b-col cols="12" md="6">
                <label>Signatario 1</label>
                <v-select label="name" :options="signatories" placeholder="Signatario 1" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer1">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
                <div v-if="signingForm.errors.signer1" class="invalid-feedback d-block" role="alert">
                    Selecciona al signatario 1
                </div>
            </b-col>
            <b-col cols="12" md="6">
                <label>Signatario 2</label>
                <v-select label="name" :options="signatories" placeholder="Signatario 2" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer2"
                          :disabled="signingForm.signer1 <= 0">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
                <div v-if="signingForm.errors.signer2" class="invalid-feedback d-block" role="alert">
                    Selecciona al signatario 2
                </div>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="12" md="6">
                <label>Signatario 3</label>
                <v-select label="name" :options="signatories" placeholder="Signatario 3" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer3"
                          :disabled="signingForm.signer2 <= 0">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
            </b-col>
            <b-col cols="12" md="6">
                <label>Signatario 4</label>
                <v-select label="name" :options="signatories" placeholder="Signatario 4" @search="getSignatories"
                          @search:focus="getSignatories" :filterable="false" v-model="signingForm.signer4"
                          :disabled="signingForm.signer3 <= 0">
                    <template slot="no-options">Sin resultados.</template>
                    <template slot="option" slot-scope="option">
                        <div class="d-center">{{ option.name }}</div>
                        <div class="d-center" v-if="option.email">{{ option.email }}</div>
                    </template>
                    <template slot="selected-option" slot-scope="option">
                        <div class="selected d-center">{{ option.name }}</div>
                    </template>
                </v-select>
            </b-col>
        </b-row>
        <template #modal-footer="{ cancel }">
            <div>
                <b-button variant="secondary" @click="cancel()">
                    <font-awesome-icon icon="times"></font-awesome-icon> Cancelar
                </b-button>
                <b-button variant="primary" class="ml-2" @click="signCertificate">
                    <font-awesome-icon icon="signature"></font-awesome-icon> Firmar
                </b-button>
            </div>
        </template>
    </b-modal>
</template>

<script>
import * as constants from '@constants';
import { signedDocumentUrl, userListUrl } from '@routes';

export default {
    name: 'SigningModalTritonix',
    props: {
        modalPublicationItemId: Number,
        fileToSign: Object
    },
    data() {
        return {
            certifications: ['EMA', 'A2LA', 'PJLA'],
            signatories: [],
            signingForm: {
                publicationItemId: 0,
                fileId: 0,
                certification: '',
                useAutograph: false,
                useQRCode: false,
                signer1: null,
                signer2: null,
                signer3: null,
                signer4: null,
                errors: {
                    signer1: false,
                    signer2: false,
                    noCheckSelected: false
                },
                selectedSigners: []
            }
        }
    },
    methods: {
        getSignatories(search = '', loading = null) {
            if (loading) {
                loading(true);
            }

            this.axios.get(userListUrl(), {
                params: {
                    searchWord: search,
                    application: constants.BACK_OFFICE_USER,
                    signatories: true,
                    selectedSigners: this.selectedSigners
                }
            }).then(response => {
                if (response.data.code === constants.CODE_OK) {
                    this.signatories = response.data.users;
                } else {
                    this.signatories = [];
                }
            }).catch(() => {
                this.signatories = [];
            }).finally(() =>  {
                if (loading) {
                    loading(false);
                }
            });
        },
        validateSignatories() {
            this.signingForm.errors.signer1 = !this.signingForm.signer1;
            this.signingForm.errors.signer2 = !this.signingForm.signer2;
            this.signingForm.errors.noCheckSelected = (!this.signingForm.useAutograph &&
                !this.signingForm.useQRCode);

            return this.signingForm.errors.signer1 || this.signingForm.errors.signer2 ||
                this.signingForm.errors.noCheckSelected;
        },
        signCertificate() {
            this.$emit('show-overlay', true);

            if (!this.validateSignatories()) {
                this.$swal({
                    title: `¿Estás seguro de firmar el certificado?`,
                    icon: 'question'
                }).then(result => {
                    if (result.value) {
                        this.$bvModal.hide('signing-modal');

                        this.signingForm.selectedSigners.push({
                            id: this.signingForm.signer1.id,
                            position: 1
                        }, {
                            id: this.signingForm.signer2.id,
                            position: 2
                        });

                        if (this.signingForm.signer3) {
                            this.signingForm.selectedSigners.push({
                                id: this.signingForm.signer3.id,
                                position: 3
                            });
                        }

                        if (this.signingForm.signer4) {
                            this.signingForm.selectedSigners.push({
                                id: this.signingForm.signer4.id,
                                position: 4
                            });
                        }

                        this.axios.post(signedDocumentUrl(), this.signingForm).then(response => {
                            if (response.data.code === constants.CODE_OK) {
                                this.$root.$bvToast.toast(response.data.message, {
                                    title: 'Firma de certificado',
                                    variant: 'success'
                                });

                                this.$emit('update-file-is-signed-status', {
                                    publicationItemId: this.signingForm.publicationItemId,
                                    fileId: this.signingForm.fileId
                                });
                            } else {
                                this.$root.$bvToast.toast(response.data.message, {
                                    title: 'Firma de certificado',
                                    variant: 'danger'
                                });
                            }
                        }).catch(() => {
                            this.$root.$bvToast.toast(constants.DEFAULT_ERROR_MESSAGE, {
                                title: 'Firma de certificado',
                                variant: 'danger'
                            });
                        }).finally(() => {
                            this.$emit('show-overlay', false);
                        });
                    }
                });
            }
        }
    },
    computed: {
        selectedSigners() {
            return [this.signingForm.signer1?.id || 0, this.signingForm.signer2?.id || 0, this.signingForm.signer3?.id || 0, this.signingForm.signer4?.id || 0].join(',');
        }
    },
    watch: {
        modalPublicationItemId(val) {
            this.signingForm.publicationItemId = val;
            this.signingForm.fileId = this.fileToSign.id;
            this.signingForm.certification = '';
            this.signingForm.useAutograph = false;
            this.signingForm.useQRCode = false;
            this.signingForm.signer1 = null;
            this.signingForm.signer2 = null;
            this.signingForm.signer3 = null;
            this.signingForm.signer4 = null;
            this.signingForm.errors.signer1 = false;
            this.signingForm.errors.signer2 = false;
            this.signingForm.errors.noCheckSelected = false;
            this.signingForm.selectedSigners = [];
        },
        'signingForm.useAutograph': {
            handler(useAutograph) {
                this.signingForm.errors.noCheckSelected = (!useAutograph && !this.signingForm.useQRCode);
            },
            deep: true
        },
        'signingForm.useQRCode': {
            handler(useQRCode) {
                this.signingForm.errors.noCheckSelected = (!this.signingForm.useAutograph && !useQRCode);
            },
            deep: true
        },
        'signingForm.signer1': {
            handler(signer1) {
                this.signingForm.errors.signer1 = !signer1

                if (!signer1) {
                    this.signingForm.signer2 = null;
                    this.signingForm.signer3 = null;
                    this.signingForm.signer4 = null;
                }
            },
            deep: true
        },
        'signingForm.signer2': {
            handler(signer2) {
                this.signingForm.errors.signer2= !signer2

                if (!signer2) {
                    this.signingForm.signer3 = null;
                    this.signingForm.signer4 = null;
                }
            },
            deep: true
        },
        'signingForm.signer3': {
            handler(signer3) {
                if (!signer3) {
                    this.signingForm.signer4 = null;
                }
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>